import React, { useCallback } from 'react';
import { SwitchField } from './switch-field';
import { Utils } from './utils';

export const SwitchCustomField = ({
  title,
  description,
  titleClassName,
  descriptionClassName,
  abledDescription,
  className,
  name,
  disabled,
  defaultValue,
  noSaveIndicator,
  onChange: onChange_,
  spaceInBetween = true,
  locked=false,
  tooltip
}: SwitchCustomField.SwitchCustomFieldProps): React.ReactElement => {
  const field = Utils.useField<boolean>(name);

  const onChange = useCallback(
    (v: boolean): void => {
      if(disabled){
        return;
      }
      onChange_?.(v);
      field?.helpers.setValue(v);
    },
    [field?.helpers]
  );

  const checked =
    field?.meta.value !== undefined ? field.meta.value : defaultValue ? defaultValue : false;

  return (
    <SwitchField
      className={className}
      abledDescription={abledDescription}
      tooltip={tooltip}
      title={title}
      name={name}
      titleClassName={titleClassName}
      description={description}
      descriptionClassName={descriptionClassName}
      noSaveIndicator={noSaveIndicator}
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      spaceInBetween={spaceInBetween}
      locked={locked}
    />
  );
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export namespace SwitchCustomField {
  export interface SwitchCustomFieldProps {
    title: React.ReactNode;
    description?: React.ReactNode;
    abledDescription?: boolean;
    titleClassName?: string;
    descriptionClassName?: string;
    disabled?: boolean;
    defaultValue?: boolean;
    className?: string;
    name: string;
    noSaveIndicator?: boolean;
    spaceInBetween?: boolean;
    locked?:boolean;
    onChange?: (v: boolean) => void;
    tooltip?: string;
  }
}
